export const communityReferrals = {
  SET_STATS_LOADING: "COMMUNITY_REFERRALS_SET_STATS_LOADING",
  GET_STATS_SUCCESS: "COMMUNITY_REFERRALS_GET_STATS_SUCCESS",
  GET_STATS_FAIL: "COMMUNITY_REFERRALS_GET_STATS_FAIL",
  SET_QUERY: "COMMUNITY_REFERRALS_SET_QUERY",
  SET_REFERRALS_LOADING: "COMMUNITY_REFERRALS_SET_REFERRALS_LOADING",
  GET_REFERRALS_SUCCESS: "COMMUNITY_REFERRALS_GET_REFERRALS_SUCCESS",
  GET_REFERRALS_FAIL: "COMMUNITY_REFERRALS_GET_REFERRALS_FAIL",
  // GROWTH-8125: the redesigned list
  V2_LIST_REQUEST: "COMMUNITY_REFERRALS_V2_LIST_REQUEST",
  V2_LIST_SUCCESS: "COMMUNITY_REFERRALS_V2_LIST_SUCCESS",
  V2_LIST_FAIL: "COMMUNITY_REFERRALS_V2_LIST_FAIL",
  V2_COUNTS_SUCCESS: "COMMUNITY_REFERRALS_V2_COUNTS_SUCCESS",
  V2_COUNTS_FAIL: "COMMUNITY_REFERRALS_V2_COUNTS_FAIL",
  V2_FOLLOWS_SUCCESS: "COMMUNITY_REFERRALS_V2_FOLLOWS_SUCCESS",
  V2_FOLLOWS_FAIL: "COMMUNITY_REFERRALS_V2_FOLLOWS_FAIL",
  V2_CLEAR: "COMMUNITY_REFERRALS_V2_CLEAR"
};
